import { useMedia } from 'react-use';

export const useDesktopLayout = (): boolean => {
  return useMedia('(min-width: 768px)');
};
